import React, { useEffect } from 'react';
import styled from 'styled';

import { Confirm } from 'components/ui/modal';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { DeleteEventPointOfInterestRequest } from 'generated/mos/org/getty/audiomanagement';
import { EventPointOfInterest } from 'generated/mos/org/getty/audio'

import { getResolvedValue } from 'helpers/linkables'
import { pick } from 'helpers/core'
import { Status, statusSelector } from 'helpers/status';

import { eventPointOfInterestSchema } from '../../../schemas/event-point-of-interest'

type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteEventPointOfInterestRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'eventPointOfInterestDelete' | 'eventPointOfInterestUpdate'>;

type DirectProps = {
  readonly historyPush: (id: string) => void;
  readonly projectId: string;
  readonly pointOfInterest: EventPointOfInterest.Entity | undefined;
  readonly moodId?: string;
  readonly onCancel: () => void;
};
type Props = ActionProps & ConnectedProps & DirectProps;

const EventPointOfInterestDeleteView = (props: Props) => {
  const {
    historyPush,
    projectId,
    gettyDeleteEventPointOfInterestRequest,
    toastNotification,
    eventPointOfInterestDelete,
    eventPointOfInterestUpdate,
    onCancel,
    moodId,
    pointOfInterest
  } = props

  const payload: DeleteEventPointOfInterestRequest.Entity = {
    ...DeleteEventPointOfInterestRequest.defaults,
    eventPointOfInterestRef: pointOfInterest && EventPointOfInterest.mustRef(pointOfInterest.ref)
  }

  const pointOfInterestName = pointOfInterest && pointOfInterest.event ? pointOfInterest.event.title : ''

  const modalMessage = (
    <>
      <p>Are you sure you want to permanently delete "{pointOfInterestName}"?</p>
    </>
  )

  const onConfirmDelete = () => {
    gettyDeleteEventPointOfInterestRequest(payload)
    historyPush(`/project/${projectId}/mood/${moodId}`)
  }

  useEffect(() => {
    if (eventPointOfInterestDelete.status === Status.Failed) {
      toastNotification({
        type: 'error',
        text: 'Could not delete point of interest',
      });
    }
  }, [eventPointOfInterestDelete.status]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Confirm
      title="Delete point of interest?"
      onClose={onCancel}
      message={modalMessage}
      confirmLabel="Delete"
      onConfirm={onConfirmDelete}
      danger
    />
  );
};

export const EventPointOfInterestDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'eventPointOfInterestDelete', 'eventPointOfInterestUpdate'),
  {
    ...pick(actionCreators, 'gettyDeleteEventPointOfInterestRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(EventPointOfInterestDeleteView)
